import { useLocation, useNavigate } from 'react-router-dom';

function PathItem({ label, onClick }) {
  return (
    <button
      type="button"
      className="dashboard-nav-item dashboard-nav-item-breadcrumb"
      onClick={onClick}
      disabled={!onClick}
    >
      {label}
    </button>
  );
}

function AnalyticsBreadcrumbNav({ hierarchy, basePath, writeSelection, showUserLevel = true }) {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    clientId,
    regionId,
    teamId,
    userId,
    selectedClient,
    selectedRegion,
    selectedTeam,
    selectedUser,
    loading,
    error,
    setRegion,
    setTeam,
    setUser,
  } = hierarchy;

  const isAnalyticsBootcamp = location.pathname.startsWith('/bootcamp/') && !!clientId;

  const goToAnalytics = (selection) => {
    writeSelection({
      client: selection.client || '',
      region: selection.region || '',
      team: selection.team || '',
      user: selection.user || '',
    });
    const params = new URLSearchParams();
    if (selection.client) params.set('client', selection.client);
    if (selection.region) params.set('region', selection.region);
    if (selection.team) params.set('team', selection.team);
    if (selection.user) params.set('user', selection.user);
    navigate(`${basePath}?${params.toString()}`, { replace: true });
  };

  if (!clientId) return null;

  if (loading) {
    return <div className="dashboard-analytics-control dashboard-hierarchy-loading">Loading…</div>;
  }

  if (error) {
    return (
      <div className="dashboard-analytics-control">
        <div className="modern-error" style={{ margin: '12px 6px', fontSize: 13 }}>{error}</div>
      </div>
    );
  }

  const clientName = selectedClient?.business_name || 'Client';

  return (
    <div className="dashboard-analytics-control">
      <div className="dashboard-analytics-path">
        <PathItem
          label={clientName}
          onClick={regionId ? () => (
            isAnalyticsBootcamp
              ? goToAnalytics({ client: clientId })
              : setRegion('')
          ) : undefined}
        />
        {regionId && (
          <PathItem
            label={selectedRegion?.name || 'Region'}
            onClick={teamId ? () => (
              isAnalyticsBootcamp
                ? goToAnalytics({ client: clientId, region: regionId })
                : setTeam('')
            ) : undefined}
          />
        )}
        {teamId && (
          <PathItem
            label={selectedTeam?.name || 'Team'}
            onClick={showUserLevel && userId ? () => setUser('') : undefined}
          />
        )}
        {showUserLevel && userId && (
          <PathItem label={selectedUser?.displayName || 'User'} />
        )}
      </div>
    </div>
  );
}

export default AnalyticsBreadcrumbNav;
